import React from 'react';

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading snacks...</p>
    </div>
  );
};

export default Loading;
